// Sentry gets the page address with every error and every breadcrumb. The session key (k) and
// the other secrets in ga.ts's SECRET_PARAMS never go with it: k goes to our own back end only.

import { withoutSecrets } from "./ga";

const cleanQueryString = (query: any): any => {
  if (typeof query !== "string") return undefined;
  const cleaned = withoutSecrets(`/?${query.replace(/^\?/, "")}`).replace(/^\/\??/, "");
  return cleaned || undefined;
};

export const scrubSentryEvent = (event: any): any => {
  try {
    const request = event && event.request;
    if (request) {
      if (request.url) request.url = withoutSecrets(request.url);
      if ("query_string" in request) request.query_string = cleanQueryString(request.query_string);
      if (request.headers && request.headers.Referer) request.headers.Referer = withoutSecrets(request.headers.Referer);
    }
    const crumbs = event && event.breadcrumbs;
    if (Array.isArray(crumbs)) event.breadcrumbs = crumbs.map(scrubSentryBreadcrumb);
    return event;
  } catch (e) {
    return event;
  }
};

export const scrubSentryBreadcrumb = (crumb: any): any => {
  try {
    const data = crumb && crumb.data;
    if (data) {
      ["url", "from", "to"].forEach((key) => {
        if (typeof data[key] === "string") data[key] = withoutSecrets(data[key]);
      });
    }
    return crumb;
  } catch (e) {
    return crumb;
  }
};
